import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export type AuthChangePasswordServiceInput = {
  payload: {
    token?: string
    newPassword: string
  }
}

export const authChangePasswordService = async ({
  payload,
}: AuthChangePasswordServiceInput): Promise<ResponseAPI> => {
  const response = await api.post('trocarsenha', {
    token: payload.token,
    senha: payload.newPassword,
  })

  return response.data
}
